import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const DateRangeDraggable = () => {
  const id = v4()
  const type = FormItemType.DateRange

  return (
    <FormItemDraggableBase
      icon={IconEnum.Calendar}
      id={id}
      title="formBuilder.dateRangeField"
      type={type}
    />
  )
}
